import { render, staticRenderFns } from "./MenuMyAccount.vue?vue&type=template&id=493edd15&"
import script from "./MenuMyAccount.vue?vue&type=script&lang=js&"
export * from "./MenuMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports